module.exports = __webpack_public_path__ + "media/images/new-beginner_icon-de6b4a6389bcf59b1d602eb389f47fc7.png";